
import * as React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import Loader from '__common/components/LoaderComponent';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { products } from '__common/constants/products';

type Props = {
  dispatch: Function;
  helioscopeDesignsList: helioscopeDesignsListState;
  projectID: string;
  user: userState;
};

export default class HelioscopeDesignsList extends React.Component<Props, {}> {
  rows() {
    const { helioscopeDesignsList, projectID, user } = this.props;
    const designs = helioscopeDesignsList.designs;

    return (
      <TableBody>
        {designs.map(design => {
          const is_dt = design.is_dt;

          return design.field_segments_.map((segment, index) => {
            const isFirst = index === 0;
            return (
              <TableRow
                key={`helioscope-designs-list-component-table-${segment.description +
                  index}`}
                className={isFirst ? 'border-top' : 'no-border'}
              >
                <TableCell>{isFirst && design.description}</TableCell>
                {isFirst? this.renderDesignImports(is_dt, projectID, design.design_id, user): <TableCell/>}
                <TableCell>{segment.description}</TableCell>
                {this.renderImports(is_dt, projectID, design.design_id, segment.field_segment_id, user)}
              </TableRow>
            );
          });
        })}
      </TableBody>
    );
  }

  renderDesignImports = (is_dt: boolean, projectId: string, designId: string, user: userState) => {
    return is_dt ? (
      <TableCell>
        <NavLink
          className="rmDt-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/rm_dt`}
        >
          RM DT
        </NavLink>
      </TableCell>
    ) : (
      <TableCell>
        <NavLink
          className="rm5-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/rm_5`}
        >
          RM 5
        </NavLink>
        { user.products.includes(products.rm) && <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/rm`}
        >
          RM 10
        </NavLink> }         
        { user.products.includes(products.rm_gridflex) && <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/rm_gridflex`}
        >
          RM GridFlex 5
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/rm_10_evolution`}
        >
          RM 10 Evo
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/ecofoot2_plus`}
        >
          EcoFoot2+
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId}/solarmount_2`}
        >
          Solar Mount Flush
        </NavLink>  }
        { <NavLink
          className="nxt-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/nxt_umount`}
        >
          NXT UMOUNT
        </NavLink>  }
      </TableCell>
    );
  }

  renderImports = (is_dt: boolean, projectId: string, designId: string, segmentId: string, user: userState) => {
    return is_dt ? (
      <TableCell>
        <NavLink
          className="rmDt-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/rm_dt`}
        >
          RM DT
        </NavLink>
      </TableCell>
    ) : (
      <TableCell>
        <NavLink
          className="rm5-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/rm_5`}
        >
          RM 5
        </NavLink>
        { user.products.includes(products.rm) && <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/rm`}
        >
          RM 10
        </NavLink>   }       
        { user.products.includes(products.rm_gridflex) && <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/rm_gridflex`}
        >
          RM GridFlex 5
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/rm_10_evolution`}
        >
          RM 10 Evo
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/ecofoot2_plus`}
        >
          EcoFoot2+
        </NavLink>  }
        { <NavLink
          className="nxt-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId
          }/${segmentId}/nxt_umount`}
        >
          NXT UMOUNT
        </NavLink>  }
        { <NavLink
          className="rm10-project-design import-design-link"
          to={`/hs/design/config/${projectId}/${
            designId}/${segmentId}/solarmount_2`}
        >
          Solar Mount Flush
        </NavLink>  }
      </TableCell>
    );
  }

  render() {
    const { helioscopeDesignsList } = this.props;

    return helioscopeDesignsList.designs.length ? (
      <div className="helioscope_designs_list">
        <Table className="designs-table" plain={true}>
          <TableCell>
            <TableRow>
              <TableCell>
                <FormattedMessage id="design" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="import.design.as" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="field.segment" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="import.segment.as" />
              </TableCell>
            </TableRow>
          </TableCell>
          {this.rows()}
        </Table>
      </div>
    ) : (
      <Loader />
    );
  }
}
